import FormScheme, { ClassType, FormGroup, FormItem } from "./FormScheme";

export default class ComponentRegitor {

    static UIComponents: ClassType[] = []
    static UIComponentsMap: Map<string, ClassType> = new Map();

    static registorClass(type: ClassType) {
        ComponentRegitor.UIComponents.push(type)
        ComponentRegitor.UIComponentsMap.set(type.componentTag, type)
    }

}
const RegistorClass = ComponentRegitor.registorClass;
const UIComponents = ComponentRegitor.UIComponents || [];
const UIComponentsMap: Map<string, ClassType> = ComponentRegitor.UIComponentsMap || {};

const SetComponent = function (fs: FormScheme) {
    if (fs.class) {
        let tag = fs.class.componentTag;
        if (tag && !fs.class.componentObject) {
            let classType: any = UIComponentsMap.get(tag);

            fs.class.componentObject = classType.componentObject
            let defaultProps = Object.assign({}, classType.defaultProps) || {};
            fs.props = Object.assign(defaultProps, fs.props)
            fs.class.scheme = classType.scheme
        }
    }
    if (fs.children) {
        setUIComponentsChildren(fs.children)
    }
}
const setUIComponentsChildren = function (items: (FormGroup | FormItem)[]) {
    for (const item of items) {
        if ((item as FormGroup).children) {
            setUIComponentsChildren((item as FormGroup).children)
        }
        if ((item as FormItem).class) {
            let tag = (item as FormItem).class.componentTag;
            if (tag && !(item as FormItem).class.componentObject) {
                let classType: any = UIComponentsMap.get(tag);
                (item as FormItem).class.componentObject = classType.componentObject
                let defaultProps = Object.assign({}, classType.defaultProps) || {};
                (item as FormItem).props = Object.assign(defaultProps, (item as FormItem).props);
                (item as FormItem).class.scheme = classType.scheme
            }
        }

    }
}

const CommonScheme = {
    key: "test",
    name: "testName",
    props: {},
    children: [
        {
            class: {
                componentTag: "AntInput",
            },
            key: "span",
            name: "占位数",
            props: {
                // span: 6,
                required: true,
                label: "占位数"
            }
        },
        {
            class: {
                componentTag: "AntInput",
            },
            key: "label",
            name: "显示名",
            props: {
                // span: 6,
                label: "显示名"
            }
        },
    ]
}

export { RegistorClass, UIComponents, UIComponentsMap, SetComponent, CommonScheme };